module.exports = __webpack_public_path__ + "img/image.30b9e810.png";